import React, { useState } from 'react';
import { Settings } from 'lucide-react';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton, BulkFieldRow, bulkSelectClass } from '../BulkFieldRow';

interface BulkConditionFieldProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkConditionField({ onUpdate }: BulkConditionFieldProps) {
  const [condition, setCondition] = useState('');

  const handleApply = () => {
    if (condition) {
      onUpdate({ condition });
      setCondition('');
    }
  };

  return (
    <BulkFieldRow
      icon={<Settings className="w-5 h-5 text-gray-500 shrink-0" />}
      label="商品の状態を変更"
    >
      <select
        value={condition}
        onChange={(e) => setCondition(e.target.value)}
        className={bulkSelectClass}
      >
        <option value="">選択してください</option>
        <option value="new">未使用</option>
        <option value="like-new">未使用に近い</option>
        <option value="good">目立った傷や汚れなし</option>
        <option value="fair">やや傷や汚れあり</option>
        <option value="poor">傷や汚れあり</option>
        <option value="bad">全体的に状態が悪い</option>
      </select>
      <BulkApplyButton disabled={!condition} onClick={handleApply} />
    </BulkFieldRow>
  );
}
